import {createApp} from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import moment from "moment";
import axios from "axios";

const bookItems = document.querySelectorAll('.webien-kiruna-book');
const monthNames = ["Januari", "Februari", "Mars", "April", "Maj", "Juni",
    "Juli", "Augusti", "September", "Oktober", "November", "December"
];
const monthNamesShort = ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"
];
const bookingStorageKey = 'bookingData';
const partnerCartStorageKey = 'partnerCart';
const bookingDataEvent = 'bookingDataUpdated';
const partnerCartEvent = 'partnerCartUpdated';
const pageNoScrollClass = 'no-scroll';
const countryList = [{"name": "Afghanistan", "code": "AF"}, {"name": "Albanien", "code": "AL"}, {
    "name": "Algeriet",
    "code": "DZ"
}, {"name": "Amerikanska Jungfruöarna", "code": "VI"}, {"name": "Amerikanska Samoa", "code": "AS"}, {
    "name": "Andorra",
    "code": "AD"
}, {"name": "Angola", "code": "AO"}, {"name": "Anguilla", "code": "AI"}, {
    "name": "Antarktis",
    "code": "AQ"
}, {"name": "Antigua och Barbuda", "code": "AG"}, {"name": "Argentina", "code": "AR"}, {
    "name": "Armenien",
    "code": "AM"
}, {"name": "Aruba", "code": "AW"}, {"name": "Australien", "code": "AU"}, {
    "name": "Azerbajdzjan",
    "code": "AZ"
}, {"name": "Bahamas", "code": "BS"}, {"name": "Bahrain", "code": "BH"}, {
    "name": "Bangladesh",
    "code": "BD"
}, {"name": "Barbados", "code": "BB"}, {"name": "Belarus", "code": "BY"}, {
    "name": "Belgien",
    "code": "BE"
}, {"name": "Belize", "code": "BZ"}, {"name": "Benin", "code": "BJ"}, {
    "name": "Bermuda",
    "code": "BM"
}, {"name": "Bhutan", "code": "BT"}, {"name": "Bolivia", "code": "BO"}, {
    "name": "Bosnien och Hercegovina",
    "code": "BA"
}, {"name": "Botswana", "code": "BW"}, {"name": "Bouvetön", "code": "BV"}, {
    "name": "Brasilien",
    "code": "BR"
}, {"name": "Brittiska Jungfruöarna", "code": "VG"}, {
    "name": "Brittiska territoriet i Indiska oceanen",
    "code": "IO"
}, {"name": "Brunei", "code": "BN"}, {"name": "Bulgarien", "code": "BG"}, {
    "name": "Burkina Faso",
    "code": "BF"
}, {"name": "Burundi", "code": "BI"}, {"name": "Caymanöarna", "code": "KY"}, {
    "name": "Centralafrikanska republiken",
    "code": "CF"
}, {"name": "Chile", "code": "CL"}, {"name": "Colombia", "code": "CO"}, {
    "name": "Cooköarna",
    "code": "CK"
}, {"name": "Costa Rica", "code": "CR"}, {"name": "Curaçao", "code": "CW"}, {
    "name": "Cypern",
    "code": "CY"
}, {"name": "Danmark", "code": "DK"}, {"name": "Djibouti", "code": "DJ"}, {
    "name": "Dominica",
    "code": "DM"
}, {"name": "Dominikanska republiken", "code": "DO"}, {"name": "Ecuador", "code": "EC"}, {
    "name": "Egypten",
    "code": "EG"
}, {"name": "Ekvatorialguinea", "code": "GQ"}, {"name": "El Salvador", "code": "SV"}, {
    "name": "Elfenbenskusten",
    "code": "CI"
}, {"name": "Eritrea", "code": "ER"}, {"name": "Estland", "code": "EE"}, {
    "name": "Eswatini",
    "code": "SZ"
}, {"name": "Etiopien", "code": "ET"}, {"name": "Falklandsöarna", "code": "FK"}, {
    "name": "Fiji",
    "code": "FJ"
}, {"name": "Filippinerna", "code": "PH"}, {"name": "Finland", "code": "FI"}, {
    "name": "Frankrike",
    "code": "FR"
}, {"name": "Franska Guyana", "code": "GF"}, {
    "name": "Franska Polynesien",
    "code": "PF"
}, {"name": "Franska sydterritorierna", "code": "TF"}, {
    "name": "Färöarna",
    "code": "FO"
}, {"name": "Förenade Arabemiraten", "code": "AE"}, {"name": "Gabon", "code": "GA"}, {
    "name": "Gambia",
    "code": "GM"
}, {"name": "Georgien", "code": "GE"}, {"name": "Ghana", "code": "GH"}, {
    "name": "Gibraltar",
    "code": "GI"
}, {"name": "Grekland", "code": "GR"}, {"name": "Grenada", "code": "GD"}, {
    "name": "Grönland",
    "code": "GL"
}, {"name": "Guadeloupe", "code": "GP"}, {"name": "Guam", "code": "GU"}, {
    "name": "Guatemala",
    "code": "GT"
}, {"name": "Guernsey", "code": "GG"}, {"name": "Guinea", "code": "GN"}, {
    "name": "Guinea-Bissau",
    "code": "GW"
}, {"name": "Guyana", "code": "GY"}, {"name": "Haiti", "code": "HT"}, {
    "name": "Heardön och McDonaldöarna",
    "code": "HM"
}, {"name": "Honduras", "code": "HN"}, {"name": "Hongkong SAR", "code": "HK"}, {
    "name": "Indien",
    "code": "IN"
}, {"name": "Indonesien", "code": "ID"}, {"name": "Irak", "code": "IQ"}, {
    "name": "Iran",
    "code": "IR"
}, {"name": "Irland", "code": "IE"}, {"name": "Island", "code": "IS"}, {
    "name": "Isle of Man",
    "code": "IM"
}, {"name": "Israel", "code": "IL"}, {"name": "Italien", "code": "IT"}, {
    "name": "Jamaica",
    "code": "JM"
}, {"name": "Japan", "code": "JP"}, {"name": "Jemen", "code": "YE"}, {
    "name": "Jersey",
    "code": "JE"
}, {"name": "Jordanien", "code": "JO"}, {"name": "Julön", "code": "CX"}, {
    "name": "Kambodja",
    "code": "KH"
}, {"name": "Kamerun", "code": "CM"}, {"name": "Kanada", "code": "CA"}, {
    "name": "Kap Verde",
    "code": "CV"
}, {"name": "Karibiska Nederländerna", "code": "BQ"}, {"name": "Kazakstan", "code": "KZ"}, {
    "name": "Kenya",
    "code": "KE"
}, {"name": "Kina", "code": "CN"}, {"name": "Kirgizistan", "code": "KG"}, {
    "name": "Kiribati",
    "code": "KI"
}, {"name": "Kokosöarna", "code": "CC"}, {"name": "Komorerna", "code": "KM"}, {
    "name": "Kongo-Brazzaville",
    "code": "CG"
}, {"name": "Kongo-Kinshasa", "code": "CD"}, {"name": "Kroatien", "code": "HR"}, {
    "name": "Kuba",
    "code": "CU"
}, {"name": "Kuwait", "code": "KW"}, {"name": "Laos", "code": "LA"}, {
    "name": "Lesotho",
    "code": "LS"
}, {"name": "Lettland", "code": "LV"}, {"name": "Libanon", "code": "LB"}, {
    "name": "Liberia",
    "code": "LR"
}, {"name": "Libyen", "code": "LY"}, {"name": "Liechtenstein", "code": "LI"}, {
    "name": "Litauen",
    "code": "LT"
}, {"name": "Luxemburg", "code": "LU"}, {"name": "Macao SAR", "code": "MO"}, {
    "name": "Madagaskar",
    "code": "MG"
}, {"name": "Malawi", "code": "MW"}, {"name": "Malaysia", "code": "MY"}, {
    "name": "Maldiverna",
    "code": "MV"
}, {"name": "Mali", "code": "ML"}, {"name": "Malta", "code": "MT"}, {
    "name": "Marocko",
    "code": "MA"
}, {"name": "Marshallöarna", "code": "MH"}, {"name": "Martinique", "code": "MQ"}, {
    "name": "Mauretanien",
    "code": "MR"
}, {"name": "Mauritius", "code": "MU"}, {"name": "Mayotte", "code": "YT"}, {
    "name": "Mexiko",
    "code": "MX"
}, {"name": "Mikronesien", "code": "FM"}, {"name": "Moldavien", "code": "MD"}, {
    "name": "Monaco",
    "code": "MC"
}, {"name": "Mongoliet", "code": "MN"}, {"name": "Montenegro", "code": "ME"}, {
    "name": "Montserrat",
    "code": "MS"
}, {"name": "Moçambique", "code": "MZ"}, {"name": "Myanmar (Burma)", "code": "MM"}, {
    "name": "Namibia",
    "code": "NA"
}, {"name": "Nauru", "code": "NR"}, {"name": "Nederländerna", "code": "NL"}, {
    "name": "Nepal",
    "code": "NP"
}, {"name": "Nicaragua", "code": "NI"}, {"name": "Niger", "code": "NE"}, {
    "name": "Nigeria",
    "code": "NG"
}, {"name": "Niue", "code": "NU"}, {"name": "Nordkorea", "code": "KP"}, {
    "name": "Nordmakedonien",
    "code": "MK"
}, {"name": "Nordmarianerna", "code": "MP"}, {"name": "Norfolkön", "code": "NF"}, {
    "name": "Norge",
    "code": "NO"
}, {"name": "Nya Kaledonien", "code": "NC"}, {"name": "Nya Zeeland", "code": "NZ"}, {
    "name": "Oman",
    "code": "OM"
}, {"name": "Pakistan", "code": "PK"}, {"name": "Palau", "code": "PW"}, {
    "name": "Palestinska territorierna",
    "code": "PS"
}, {"name": "Panama", "code": "PA"}, {"name": "Papua Nya Guinea", "code": "PG"}, {
    "name": "Paraguay",
    "code": "PY"
}, {"name": "Peru", "code": "PE"}, {"name": "Pitcairnöarna", "code": "PN"}, {
    "name": "Polen",
    "code": "PL"
}, {"name": "Portugal", "code": "PT"}, {"name": "Puerto Rico", "code": "PR"}, {
    "name": "Qatar",
    "code": "QA"
}, {"name": "Rumänien", "code": "RO"}, {"name": "Rwanda", "code": "RW"}, {
    "name": "Ryssland",
    "code": "RU"
}, {"name": "Réunion", "code": "RE"}, {"name": "S:t Barthélemy", "code": "BL"}, {
    "name": "S:t Helena",
    "code": "SH"
}, {"name": "S:t Kitts och Nevis", "code": "KN"}, {
    "name": "S:t Lucia",
    "code": "LC"
}, {"name": "S:t Pierre och Miquelon", "code": "PM"}, {
    "name": "S:t Vincent och Grenadinerna",
    "code": "VC"
}, {"name": "Saint-Martin", "code": "MF"}, {"name": "Salomonöarna", "code": "SB"}, {
    "name": "Samoa",
    "code": "WS"
}, {"name": "San Marino", "code": "SM"}, {"name": "Saudiarabien", "code": "SA"}, {
    "name": "Schweiz",
    "code": "CH"
}, {"name": "Senegal", "code": "SN"}, {"name": "Serbien", "code": "RS"}, {
    "name": "Seychellerna",
    "code": "SC"
}, {"name": "Sierra Leone", "code": "SL"}, {"name": "Singapore", "code": "SG"}, {
    "name": "Sint Maarten",
    "code": "SX"
}, {"name": "Slovakien", "code": "SK"}, {"name": "Slovenien", "code": "SI"}, {
    "name": "Somalia",
    "code": "SO"
}, {"name": "Spanien", "code": "ES"}, {"name": "Sri Lanka", "code": "LK"}, {
    "name": "Storbritannien",
    "code": "GB"
}, {"name": "Sudan", "code": "SD"}, {"name": "Surinam", "code": "SR"}, {
    "name": "Svalbard och Jan Mayen",
    "code": "SJ"
}, {"name": "Sverige", "code": "SE"}, {"name": "Sydafrika", "code": "ZA"}, {
    "name": "Sydgeorgien och Sydsandwichöarna",
    "code": "GS"
}, {"name": "Sydkorea", "code": "KR"}, {"name": "Sydsudan", "code": "SS"}, {
    "name": "Syrien",
    "code": "SY"
}, {"name": "São Tomé och Príncipe", "code": "ST"}, {"name": "Tadzjikistan", "code": "TJ"}, {
    "name": "Taiwan",
    "code": "TW"
}, {"name": "Tanzania", "code": "TZ"}, {"name": "Tchad", "code": "TD"}, {
    "name": "Thailand",
    "code": "TH"
}, {"name": "Tjeckien", "code": "CZ"}, {"name": "Togo", "code": "TG"}, {
    "name": "Tokelauöarna",
    "code": "TK"
}, {"name": "Tonga", "code": "TO"}, {"name": "Trinidad och Tobago", "code": "TT"}, {
    "name": "Tunisien",
    "code": "TN"
}, {"name": "Turkiet", "code": "TR"}, {"name": "Turkmenistan", "code": "TM"}, {
    "name": "Turks- och Caicosöarna",
    "code": "TC"
}, {"name": "Tuvalu", "code": "TV"}, {"name": "Tyskland", "code": "DE"}, {
    "name": "Uganda",
    "code": "UG"
}, {"name": "Ukraina", "code": "UA"}, {"name": "Ungern", "code": "HU"}, {
    "name": "Uruguay",
    "code": "UY"
}, {"name": "USA", "code": "US"}, {"name": "USA:s yttre öar", "code": "UM"}, {
    "name": "Uzbekistan",
    "code": "UZ"
}, {"name": "Vanuatu", "code": "VU"}, {"name": "Vatikanstaten", "code": "VA"}, {
    "name": "Venezuela",
    "code": "VE"
}, {"name": "Vietnam", "code": "VN"}, {"name": "Västsahara", "code": "EH"}, {
    "name": "Wallis- och Futunaöarna",
    "code": "WF"
}, {"name": "Zambia", "code": "ZM"}, {"name": "Zimbabwe", "code": "ZW"}, {
    "name": "Åland",
    "code": "AX"
}, {"name": "Österrike", "code": "AT"}, {"name": "Östtimor", "code": "TL"}];

bookItems.forEach((item) => {

    let $app = createApp({
        name: "bookItem-" + item.dataset.unique,
        data() {
            return {
                settings: window['widgetSettings_' + item.dataset.unique],
                title: 'App - ' + item.dataset.unique,
                countryList: countryList,
                bookCardOpen: false,
                overlay: {
                    open: false,
                    scene: null,
                },
                booking: {
                    loading: false,
                    error: null,
                    rezdyOrder: null,
                },
                message: {
                    title: null,
                    text: null,
                    cta: 'Ok',
                },
                summary: {
                    editingRoute: false,
                },
                calendar: {
                    date: new Date(),
                    lastValidDate: new Date(),
                    minDate: new Date(),
                    available: [],
                    availableKeys: [],
                    slotsByDate: {},
                    selectedSlots: [],
                },
                order: {
                    contact: {
                        fname: null,
                        lname: null,
                        email: null,
                        phone: null,
                        country: 'SE',
                    },
                    productCode: null,
                    // Number per Rezdy price option, keyed by option id.
                    quantities: {},
                    // Booking fields asked once per booking, keyed by Rezdy label.
                    fields: {},
                    // One object per participant, keyed by Rezdy label.
                    participants: [],
                    // Chosen extras, keyed by extra name.
                    extras: {},
                    image: null,
                    title: null,
                    extra: {
                        pickup: null,
                        note: '',
                    },
                    slot: null,
                    rezdy: null,
                    rezdyBooking: null,
                    stripeCheckoutSessionId: null,
                    payAgreement: false,
                    promo: {
                        code: null,
                        valid: false,
                        originalTotal: null,
                        newTotal: null,
                        discountAmount: null,
                        currency: null,
                    }
                },
                promoDraft: {
                    code: '',
                    valid: null,
                    checking: false,
                    message: '',
                    result: null,
                },
                partnerCart: {
                    contact: {
                        company: null,
                        fname: null,
                        lname: null,
                        email: null,
                        phone: null,
                        country: 'SE',
                    },
                    extra: {
                        note: '',
                    },
                    items: [],
                    payAgreement: false
                },
                partnerDraft: {
                    mode: 'add',
                    id: null,
                    editIndex: null,
                    product: null,
                    travelers: 1,
                    desiredDate: null,
                    desiredPickup: null,
                    guideLanguage: null,
                    resource: null,
                    comment: '',
                    createdAt: null,
                },
                partnerGuideLanguages: ['Svenska', 'Norska', 'Finska'],
                syncingPartnerCart: false,
                stripe: {
                    $: null, // Stripe object
                    apiKey: window.stripeApiKeyPublic, // Public API Key from JS variable defined on page.
                    checkout: null,
                    actions: null,
                    paymentElement: null,
                    session: null,
                    sessionId: null,
                    clientSecret: null,
                    error: null,
                    statusMessage: null,
                    paymentResult: null,
                    loading: false,
                    processing: false,
                    canConfirm: false,
                },
                showPartnerCalendarOverlay: false,
                optionalParticipantsOpen: false,
                // Sessions are fetched after load: idle, loading, ready or error.
                availabilityState: 'idle',
                partnerQuoteResult: {
                    loading: false,
                    sending: false,
                    error: null,
                    notFound: false,
                    uuid: null,
                    quote: null,
                    entryId: null,
                    createdAt: null,
                    expandedItems: [],
                }
            }
        },
        mixins: [],
        computed: {
            resources() {
                return Array.isArray(this.settings.resources) ? this.settings.resources : [];
            },
            countryOptions() {
                const popularCodes = ['SE', 'NO', 'FI'];
                const top = popularCodes
                    .map(code => this.countryList.find(c => c.code === code))
                    .filter(Boolean);
                const rest = this.countryList.filter(c => !popularCodes.includes(c.code));
                return [...top, {separator: true}, ...rest];
            },
            destinations() {
                return Array.isArray(this.settings.destinations) ? this.settings.destinations : [];
            },
            productData() {
                return this.settings.productData || {};
            },
            termsContent() {
                const terms = this.productData.generalTerms;
                return typeof terms === 'string' && terms.trim() ? terms : this.settings.terms;
            },
            pickups() {
                return this.productData.pickups || [];
            },
            showPickupSelect() {
                return this.pickups.length > 1;
            },
            hasPickupOptions() {
                return this.pickups.length > 0;
            },
            selectedPickup() {
                return this.getPickupByValue(this.order.extra.pickup);
            },
            pickupText() {
                return this.selectedPickup?.locationName || '';
            },
            destinationText() {
                return this.productData.name || '';
            },
            summaryRouteSelectLabel() {
                return this.summary.editingRoute ? 'Spara' : 'Ändra';
            },
            showOverlayBottom() {
                return !['loading', 'payment', 'paymentSuccess'].includes(this.overlay.scene);
            },
            showOverlayCancel() {
                return !['message'].includes(this.overlay.scene);
            },
            canSaveOverlay() {
                if (this.overlay.scene === 'dateTime') {
                    return this.hasSelectedDateTime;
                }

                if (this.overlay.scene === 'partnerBook') {
                    return this.hasValidPartnerDraft;
                }

                if (this.overlay.scene === 'discount') {
                    return this.promoDraft.code.trim().length > 0 && !this.promoDraft.checking;
                }

                return true;
            },
            travelersText() {
                const rows = this.priceOptionRows.filter(row => row.count > 0);

                if (rows.length === 0) {
                    return 'Välj antal';
                }

                // A single price option ("Per person", "Group from 1 to 4") is shown as a count.
                if (this.priceOptionRows.length === 1) {
                    return rows[0].count + ' × ' + rows[0].label;
                }

                return rows.map(row => row.count + ' × ' + row.label).join(', ');
            },
            dateAndTimeText() {
                if (!this.hasSelectedDateTime) {
                    return 'Välj datum och tid';
                }

                const slotDate = moment(this.getSlotDateKey(this.order.slot));
                let text = slotDate.format('D') + ' ' + monthNames[slotDate.format('M') - 1];

                text += ', ' + this.formatSlotTimeRange(this.order.slot);

                return text;
            },
            overlayTitle() {
                let txt = '';
                if (this.overlay.scene === 'travelers') txt = 'Antal';
                if (this.overlay.scene === 'dateTime') txt = 'Datum och tid';
                if (this.overlay.scene === 'loading') txt = 'Förbereder bokning';
                if (this.overlay.scene === 'bookingError') txt = 'Bokningen kunde inte skapas';
                if (this.overlay.scene === 'payment') txt = 'Betalning';
                if (this.overlay.scene === 'paymentSuccess') txt = 'Betalning klar';
                if (this.overlay.scene === 'partnerBook') txt = this.isEditingPartnerDraft ? 'Ändra bokning av ' + this.partnerDraftProductName : 'Boka ' + this.partnerDraftProductName;
                if (this.overlay.scene === 'date') txt = 'Välj datum';
                if (this.overlay.scene === 'discount') txt = 'Lägg till rabattkod';
                if (this.overlay.scene === 'terms') txt = 'Villkor';
                if (this.overlay.scene === 'message') txt = this.message.title || 'Meddelande';

                return txt;
            },
            loadingOverlayText() {
                let txt = '';
                if (this.overlay.scene === 'loading') txt = 'Förbereder bokning';

                return txt;
            },
            overlayCta() {
                let txt = 'Spara';
                if (this.overlay.scene === 'discount') txt = 'Lägg till';
                if (this.overlay.scene === 'terms') txt = 'Stäng';
                if (this.overlay.scene === 'partnerBook') txt = this.isEditingPartnerDraft ? 'Uppdatera' : 'Lägg till';
                if (this.overlay.scene === 'message') txt = this.message.cta || 'Ok';

                return txt;
            },
            dateTitle() {
                return moment(this.calendar.date).format('D') + ' ' + monthNames[moment(this.calendar.date).format('M') - 1];
            },
            hasSelectedDateTime() {
                const selectedDateKey = this.getSlotDateKey(this.order.slot);

                // Before the sessions are fetched, a chosen time counts if it is still in the
                // future. The server checks seats and minimum notice when the booking is sent.
                if (this.availabilityState !== 'ready') {
                    const start = this.getSlotStartMoment(this.order.slot);

                    return Boolean(start && start.isAfter(moment()));
                }

                if (!selectedDateKey || !this.isValidDate(this.calendar.date)) {
                    return false;
                }

                return moment(this.calendar.date).format('YYYY-MM-DD') === selectedDateKey;
            },
            hasValidPartnerDraft() {
                return Boolean(
                    this.partnerDraft.product?.id &&
                    this.partnerDraft.desiredDate &&
                    Number(this.partnerDraft.travelers) > 0
                );
            },
            isEditingPartnerDraft() {
                return this.partnerDraft.mode === 'edit' || this.findPartnerCartItemIndex(this.partnerDraft.id, this.partnerDraft.editIndex) !== -1;
            },
            partnerDraftProductName() {
                return this.partnerDraft.product?.name || 'resa';
            },
            partnerQuoteButtonText() {
                return this.partnerQuoteResult.sending ? 'Skickar offertförfrågan' : 'Skicka offertförfrågan';
            },
            bookingRules() {
                return this.productData.booking || {};
            },
            priceOptionRows() {
                // One row per Rezdy price option, with the selected session's price when it has one.
                const options = this.productData.pricing?.priceOptions || [];
                const labels = this.productData.pricing?.labels || {};
                const sessionPrices = this.order.slot?.prices || {};

                return options.map(option => {
                    const key = this.getPriceOptionKey(option);

                    return {
                        key: key,
                        id: option.id ?? null,
                        rezdyLabel: option.label,
                        label: labels[option.label] || option.label,
                        price: Number(sessionPrices[String(option.id)] ?? option.price ?? 0),
                        seatsUsed: Math.max(1, Number(option.seatsUsed || 1)),
                        min: Number(option.minQuantity || 0),
                        max: option.maxQuantity ? Number(option.maxQuantity) : null,
                        count: Number(this.order.quantities?.[key] || 0),
                    };
                });
            },
            totalQuantity() {
                return this.priceOptionRows.reduce((sum, row) => sum + row.count, 0);
            },
            totalSeats() {
                return this.priceOptionRows.reduce((sum, row) => sum + row.count * row.seatsUsed, 0);
            },
            quantityMin() {
                return Number(this.bookingRules.quantityMin || 1);
            },
            quantityMax() {
                return this.bookingRules.quantityMax ? Number(this.bookingRules.quantityMax) : null;
            },
            quantityLimitText() {
                if (this.quantityMax && this.quantityMin > 1) return 'Minst ' + this.quantityMin + ', högst ' + this.quantityMax + ' per bokning.';
                if (this.quantityMax) return 'Högst ' + this.quantityMax + ' per bokning.';
                if (this.quantityMin > 1) return 'Minst ' + this.quantityMin + ' per bokning.';
                return '';
            },
            bookingFields() {
                // Fields asked once per booking, except those covered by the contact form.
                return (this.bookingRules.fields || []).filter(field => !field.contact && (field.visiblePerBooking || field.requiredPerBooking));
            },
            participantFields() {
                return (this.bookingRules.fields || []).filter(field => field.requiredPerParticipant);
            },
            optionalParticipantFields() {
                // Fields Rezdy shows per participant without requiring them, usually first and last name.
                return (this.bookingRules.fields || []).filter(field => field.visiblePerParticipant && !field.requiredPerParticipant);
            },
            showParticipantsCard() {
                // Required participant fields always show. Optional names only when booking for
                // more than one, since participant 1 is the contact person (Rezdy adds them).
                return this.participantFields.length > 0 || (this.optionalParticipantFields.length > 0 && this.totalQuantity > 1);
            },
            productExtras() {
                return this.bookingRules.extras || [];
            },
            hasDetailsCard() {
                return this.showPickupSelect || this.bookingFields.length > 0 || this.productExtras.length > 0;
            },
            extrasTotal() {
                return this.productExtras.reduce((sum, extra) => {
                    const chosen = Number(this.order.extras?.[extra.name] || 0);

                    if (chosen <= 0) return sum;
                    if (extra.priceType === 'QUANTITY') return sum + extra.price * chosen;
                    if (extra.priceType === 'PER_PERSON') return sum + extra.price * this.totalQuantity;

                    return sum + extra.price;
                }, 0);
            },
            baseTotal() {
                return this.priceOptionRows.reduce((sum, row) => sum + row.count * row.price, 0) + this.extrasTotal;
            },
            priceCurrency() {
                return this.productData.pricing?.currency || 'SEK';
            },
            hasPromoApplied() {
                return Boolean(this.order.promo?.code && this.order.promo?.valid);
            },
            effectiveTotal() {
                if (this.hasPromoApplied && this.order.promo.newTotal !== null) {
                    return Number(this.order.promo.newTotal);
                }
                return this.baseTotal;
            },
            priceText() {
                return this.formatCurrency(this.effectiveTotal, this.priceCurrency);
            },
            originalPriceText() {
                const original = this.order.promo?.originalTotal ?? this.baseTotal;
                return this.formatCurrency(original, this.priceCurrency);
            },
            stripeTotalText() {
                const stripeTotal = this.stripe.session?.total?.total?.amount;
                const lineTotal = this.stripe.session?.lineItems?.[0]?.total?.amount;

                return stripeTotal || lineTotal || this.priceText;
            },
            stripePaymentButtonText() {
                if (this.stripe.processing) return 'Bearbetar...';
                if (this.stripe.loading) return 'Laddar...';
                return 'Betala nu';
            },
            paymentSuccessOrderData() {
                const contact = this.order.contact || {};

                return {
                    orderNumber: this.getFinalOrderNumber(),
                    orderStatus: this.getFinalOrderStatus(),
                    amountPaid: this.getFinalAmountPaidText(),
                    contact: {
                        firstName: contact.fname || null,
                        lastName: contact.lname || null,
                        email: contact.email || contact.mail || null,
                        phone: contact.phone || null,
                        country: this.getContactCountryCode() || contact.country || null,
                    },
                };
            },
            partnerPriceText(){
                let price = 0;
                this.partnerCart.items.forEach((item) => {
                    price += Number(item.totPrice || 0);
                });
                return this.getFormatedPrice(price);
            },
            partnerDraftPickups() {
                let currentPickupId = this.partnerDraft.product?.pickupId;
                if(!currentPickupId || !Array.isArray(this.settings.allProductPickups)){
                    return false;
                }
                return this.settings.allProductPickups.find((pickup) =>  pickup.id === currentPickupId);
            },
            partnerSelectDateText() {
                if (!this.partnerDraft.desiredDate) {
                    return 'Välj datum';
                }

                const date = moment(this.partnerDraft.desiredDate);
                return date.format('D') + ' ' + monthNames[date.format('M') - 1];

            },
            partnerCartValid() {
                return Boolean(
                    this.partnerCart.contact?.fname &&
                    this.partnerCart.contact?.lname &&
                    this.partnerCart.contact?.email &&
                    this.partnerCart.contact?.phone &&
                    this.partnerCart.contact?.country &&
                    this.partnerCart.items.length > 0 &&
                    this.partnerCart.payAgreement
                );
            }
        },
        watch: {
            'calendar.date'(date) {
                // Updates the visible slots when the user selects a calendar date.
                if (!this.isValidDate(date) || !this.isCalendarDateSelectable(date)) {
                    this.calendar.date = this.calendar.lastValidDate;
                    return;
                }

                this.calendar.lastValidDate = date;
                this.updateSelectedDateSlots();
            },
            'order.extra.pickup'() {
                // Saves pickup changes and updates slot labels.
                this.updateData();
                this.updateSelectedDateSlots();
            },
            totalSeats() {
                // Sessions with too few seats for the chosen quantities are hidden.
                this.initCalendarAvailability();
            },
            totalQuantity() {
                this.resizeParticipants();
            },
            bookCardOpen() {
                this.$nextTick(() => {
                    this.updatePageScrollLock();
                });
            },
            'overlay.open'() {
                this.$nextTick(() => {
                    this.updatePageScrollLock();
                });
            },
            showPartnerCalendarOverlay() {
                this.$nextTick(() => {
                    this.updatePageScrollLock();
                });
            },
            partnerCart: {
                handler() {
                    if (this.syncingPartnerCart) {
                        return;
                    }

                    this.updatePartnerCart();
                },
                deep: true
            }
        },
        methods: {
            init() {
                this.resetData();
                this.resetPartnerCart();
                this.initPickups();
                this.initCalendarAvailability();
                this.handleStripeReturn();

                if (this.settings.view === 'partner-thank-you') {
                    this.fetchPartnerQuote();
                }

                // Listen for global event to update data
                window.addEventListener(bookingDataEvent, (event) => {
                    let data = event.detail;
                    if (data.sourceInstanceId === this.settings.instanceId) {
                        return;
                    }

                    if (data.order) {
                        this.order = data.order;
                        this.normalizeOrder();
                    }

                    this.syncProductData(data.productData);
                    this.initCalendarAvailability(true);
                });

                window.addEventListener(partnerCartEvent, (event) => {
                    const data = event.detail || {};
                    if (data.sourceInstanceId === this.settings.instanceId || !data.partnerCart) {
                        return;
                    }

                    this.syncingPartnerCart = true;
                    this.partnerCart = this.normalizePartnerCart(data.partnerCart);
                    this.$nextTick(() => {
                        this.syncingPartnerCart = false;
                    });
                });
            },
            openOverlay(scene) {
                // Save current state of order to local storage before opening overlay

                if (scene === 'payment') {
                    if (!this.order.payAgreement) {
                        this.showMessageOverlay('Du måste godkänna betalningsvillkoren innan du kan gå vidare.');
                        return;
                    } else if (!this.stripe.$) {
                        this.initStripe();
                    }

                }

                this.overlay.open = true;
                this.overlay.scene = scene;

                if (scene === 'dateTime') {
                    // Sessions are fetched the first time the date overlay opens.
                    if (this.availabilityState === 'ready') {
                        this.$nextTick(() => {
                            this.initCalendarAvailability(true);
                        });
                    } else if (this.availabilityState !== 'loading') {
                        this.loadAvailability();
                    }
                }

                if (scene === 'payment') {
                    this.$nextTick(() => {
                        this.submitBooking();
                    });
                }
            },
            closeOverlay() {
                if (['payment', 'paymentSuccess'].includes(this.overlay.scene)) {
                    this.destroyStripeCheckout();
                }

                this.overlay.open = false;
            },
            overlayBkgClicked() {
                if (['loading', 'payment', 'paymentSuccess'].includes(this.overlay.scene)) {
                    return;
                }
                this.closeOverlay();
            },
            openBookCard() {
                this.bookCardOpen = true;
            },
            closeBookCard() {
                this.bookCardOpen = false;
            },
            updatePageScrollLock() {
                const hasOpenBookCard = Boolean(document.querySelector('.webien-kiruna-book.book-card > .card.book-card-open'));
                const hasOpenOverlay = Boolean(document.querySelector('.webien-kiruna-book.book-overlay.open, .webien-kiruna-book.book-overlay .partner-calendar-overlay.show'));

                document.documentElement.classList.toggle(pageNoScrollClass, hasOpenBookCard || hasOpenOverlay);
            },
            addBooking() {
                localStorage.removeItem(partnerCartStorageKey);
                this.updateData();

                const checkoutUrl = this.settings.checkoutUrl;
                if (checkoutUrl) {
                    window.location.href = checkoutUrl;
                }
            },
            openPartnerProduct(product) {
                if (product?.product && product?.id) {
                    this.editPartnerCartItem(product);
                    return;
                }

                this.partnerDraft = this.createPartnerDraft(product, 'add');
                this.openOverlay('partnerBook');
            },
            editPartnerCartItem(itemOrIndex) {
                const resolved = this.resolvePartnerCartItem(itemOrIndex);
                const item = resolved.item;

                if (!item) {
                    return;
                }

                this.partnerDraft = this.createPartnerDraft(item.product, 'edit', item, resolved.index);
                this.openOverlay('partnerBook');
            },
            resolvePartnerCartItem(itemOrIndex) {
                if (Number.isInteger(itemOrIndex)) {
                    return {
                        item: this.partnerCart.items[itemOrIndex] || null,
                        index: itemOrIndex,
                    };
                }

                const id = typeof itemOrIndex === 'string' ? itemOrIndex : itemOrIndex?.id;
                const index = this.findPartnerCartItemIndex(id);

                return {
                    item: index !== -1 ? this.partnerCart.items[index] : itemOrIndex,
                    index: index,
                };
            },
            findPartnerCartItemIndex(id, fallbackIndex = null) {
                if (id) {
                    const index = this.partnerCart.items.findIndex((item) => item.id === id);

                    if (index !== -1) {
                        return index;
                    }
                }

                if (Number.isInteger(fallbackIndex) && this.partnerCart.items[fallbackIndex]) {
                    return fallbackIndex;
                }

                return -1;
            },
            createPartnerDraft(product, mode = 'add', item = null, editIndex = null) {
                const normalizedProduct = this.normalizePartnerProduct(product || item?.product || {});

                // If deesiredPickup is not set, check for available and set first as default
                if (!item?.desiredPickup) {
                    const availablePickups = this.settings.allProductPickups.find((pickup) => pickup.id === normalizedProduct.pickupId);
                    if (availablePickups) {
                        item = item || {};
                        item.desiredPickup = availablePickups.pickupLocations[0].locationName;
                    }
                }

                return {
                    mode: mode,
                    id: item?.id || null,
                    editIndex: editIndex,
                    product: normalizedProduct,
                    travelers: Number(item?.travelers || 1),
                    totPrice: Number(item?.travelers || 1) * normalizedProduct.price,
                    desiredDate: item?.desiredDate || null,
                    desiredPickup: item?.desiredPickup || null,
                    guideLanguage: item?.guideLanguage || null,
                    resource: item?.resource || null,
                    comment: item?.comment || '',
                    createdAt: item?.createdAt || null,
                };
            },
            normalizePartnerProduct(product) {
                return {
                    id: product?.id || product?.productCode || null,
                    productCode: product?.productCode || product?.id || null,
                    name: product?.name || '',
                    description: product?.description || '',
                    image: product?.image || null,
                    priceText: product?.priceText || '',
                    //pricing: product?.pricing || null,
                    price: Number(product?.price || 0),
                    pickupId: product?.pickupId || null,
                };
            },
            savePartnerDraft() {
                if (!this.hasValidPartnerDraft) {
                    return;
                }

                const now = new Date().toISOString();
                const existingIndex = this.findPartnerCartItemIndex(this.partnerDraft.id, this.partnerDraft.editIndex);
                const item = {
                    id: this.partnerDraft.id || this.createPartnerCartItemId(),
                    product: this.normalizePartnerProduct(this.partnerDraft.product),
                    travelers: Number(this.partnerDraft.travelers || 1),
                    desiredDate: this.partnerDraft.desiredDate || null,
                    desiredPickup: this.partnerDraft.desiredPickup || null,
                    totPrice: Number(this.partnerDraft.travelers || 1) * Number(this.partnerDraft.product?.price || 0),
                    guideLanguage: this.partnerDraft.guideLanguage || null,
                    resource: this.partnerDraft.resource || null,
                    comment: this.partnerDraft.comment || '',
                    createdAt: this.partnerDraft.createdAt || now,
                    updatedAt: now,
                };

                if (existingIndex !== -1) {
                    this.partnerCart.items.splice(existingIndex, 1, item);
                } else {
                    this.partnerCart.items.push(item);
                }

                this.updatePartnerCart();
                this.closeOverlay();
            },
            createPartnerCartItemId() {
                return 'partner-' + Date.now() + '-' + Math.random().toString(36).substring(2, 8);
            },
            initPickups() {
                // Sets the first pickup as default when no valid choice is selected.
                if (this.pickups.length === 0) {
                    return;
                }

                if (this.order.extra.pickup && this.selectedPickup) {
                    this.order.extra.pickup = this.selectedPickup;
                } else {
                    this.order.extra.pickup = this.pickups[0];
                }

                this.updateData();
            },
            getPickupByValue(value) {
                // Finds a pickup location from a stored pickup object or location name.
                if (!value) return null;

                const locationName = typeof value === 'string' ? value : value.locationName;

                return this.pickups.find(pickup => pickup.locationName === locationName) || null;
            },
            toggleSummaryRouteEdit() {
                // Toggles the summary pickup dropdown.
                this.summary.editingRoute = !this.summary.editingRoute;
                this.updateData();
            },
            async loadAvailability() {
                // Fetches the product's sessions from the server's Rezdy cache when the date
                // overlay opens. They are not part of the page HTML, so seat changes do not
                // require a page cache purge.
                const productCode = this.productData.id;

                if (!productCode || !window.webienSite?.ajaxurl) {
                    return;
                }

                this.availabilityState = 'loading';

                try {
                    const response = await axios.get(window.webienSite.ajaxurl, {
                        params: {action: 'webien_rezdy_availability', productCode: productCode},
                    });

                    if (!response.data?.success) {
                        throw new Error(response.data?.data?.message || 'Tiderna kunde inte hämtas.');
                    }

                    this.settings.productData = {...this.productData, availability: response.data.data};
                    this.availabilityState = 'ready';
                } catch (error) {
                    console.error('Availability error', error);
                    this.availabilityState = 'error';
                }

                this.initCalendarAvailability();
            },
            initCalendarAvailability() {
                // Prepares available dates and slots from the sessions fetched by loadAvailability().
                if (this.availabilityState !== 'ready') {
                    // Nothing is cleared while sessions load, so a chosen time is kept.
                    this.calendar.available = [];
                    this.calendar.availableKeys = [];
                    this.calendar.selectedSlots = [];
                    return;
                }

                const availability = this.productData.availability || {};
                const slotsByDate = this.getFutureSlotsByDate(availability.slotsByDate || {});
                const availableDates = this.getFutureAvailableDates(availability.availableDates || [], slotsByDate);
                const selectedDateKey = this.getSlotDateKey(this.order.slot);

                this.calendar.available = availableDates.map(date => new Date(date + 'T00:00:00'));
                this.calendar.availableKeys = availableDates;
                this.calendar.minDate = moment().startOf('day').toDate();
                this.calendar.slotsByDate = slotsByDate;

                if (this.order.slot && (!selectedDateKey || !availableDates.includes(selectedDateKey))) {
                    this.order.slot = null;
                    this.updateData();
                }

                if (availableDates.length > 0) {
                    const dateKey = selectedDateKey && availableDates.includes(selectedDateKey) ? selectedDateKey : availableDates[0];

                    this.calendar.date = new Date(dateKey + 'T00:00:00');
                    this.calendar.lastValidDate = this.calendar.date;
                } else {
                    this.calendar.selectedSlots = [];
                }

                this.updateSelectedDateSlots();
            },
            isCalendarDateSelectable(date) {
                // Checks that a picked date is today or later and has available slots.
                if (!this.isValidDate(date)) return false;

                const dateKey = moment(date).format('YYYY-MM-DD');

                return moment(date).isSameOrAfter(moment().startOf('day'))
                    && this.calendar.availableKeys.includes(dateKey)
                    && Array.isArray(this.calendar.slotsByDate[dateKey])
                    && this.calendar.slotsByDate[dateKey].length > 0;
            },
            getFutureSlotsByDate(slotsByDate) {
                // Keeps slots that start after the product's minimum notice and have enough seats.
                const earliest = moment().add(Number(this.bookingRules.minimumNoticeMinutes || 0), 'minutes');
                const seatsNeeded = Math.max(1, this.totalSeats);
                const futureSlotsByDate = {};

                Object.keys(slotsByDate).forEach(dateKey => {
                    const futureSlots = (slotsByDate[dateKey] || []).filter(slot => {
                        const startTime = this.getSlotStartMoment(slot);
                        const seats = slot.seatsAvailable === null || slot.seatsAvailable === undefined ? seatsNeeded : Number(slot.seatsAvailable);

                        return startTime && startTime.isSameOrAfter(earliest) && seats >= seatsNeeded;
                    });

                    if (futureSlots.length > 0) {
                        futureSlotsByDate[dateKey] = futureSlots;
                    }
                });

                return futureSlotsByDate;
            },
            getFutureAvailableDates(availableDates, slotsByDate) {
                // Gets only today and future dates that have at least one future slot.
                const today = moment().startOf('day');

                return availableDates.filter(dateKey => {
                    const date = moment(dateKey, 'YYYY-MM-DD', true);

                    return date.isValid()
                        && date.isSameOrAfter(today)
                        && Array.isArray(slotsByDate[dateKey])
                        && slotsByDate[dateKey].length > 0;
                });
            },
            getSlotStartMoment(slot) {
                // Parses the slot start time for calendar filtering.
                const startTime = slot?.startTimeLocal || slot?.startTime;

                if (typeof startTime !== 'string') {
                    return null;
                }

                const parsed = moment(startTime.replace(' ', 'T'));

                return parsed.isValid() ? parsed : null;
            },
            isValidDate(date) {
                // Checks if the calendar value is a usable Date.
                return date instanceof Date && !isNaN(date.getTime());
            },
            updateSelectedDateSlots() {
                // Loads and logs the time slots for the currently selected date.
                if (!this.isValidDate(this.calendar.date)) return;

                const dateKey = moment(this.calendar.date).format('YYYY-MM-DD');
                this.calendar.selectedSlots = this.calendar.slotsByDate[dateKey] || [];

                if (this.order.slot && this.getSlotDateKey(this.order.slot) !== dateKey) {
                    this.order.slot = null;
                    this.updateData();
                }

                console.log('Available slots for ' + dateKey, this.calendar.selectedSlots);
            },
            selectTimeSlot(slot) {
                // Stores the selected time slot on the booking order.
                this.order.slot = slot;
                this.updateData();
                console.log('Selected slot', slot);
            },
            isSelectedTimeSlot(slot) {
                // Compares by stable slot id first, then falls back to local start time.
                if (!slot || !this.order.slot) {
                    return false;
                }

                const selectedId = this.order.slot.id || this.order.slot.sessionId;
                const slotId = slot.id || slot.sessionId;

                if (selectedId && slotId) {
                    return String(selectedId) === String(slotId);
                }

                const selectedStart = this.order.slot.startTimeLocal || this.order.slot.startTime;
                const slotStart = slot.startTimeLocal || slot.startTime;

                return Boolean(selectedStart && slotStart && selectedStart === slotStart);
            },
            getPickupInstruction() {
                // Gets instructions for the selected pickup location.
                return this.selectedPickup?.additionalInstructions || null;
            },
            getPickupMinutesPrior() {
                // Gets the selected pickup time adjustment in minutes.
                return Number(this.selectedPickup?.minutesPrior || 0);
            },
            getSlotDateKey(slot) {
                // Gets the YYYY-MM-DD date key for a time slot.
                const startTime = slot?.startTimeLocal || slot?.startTime;

                return typeof startTime === 'string' ? startTime.substring(0, 10) : null;
            },
            formatSlotTime(slot, key, adjustPickupTime = false) {
                // Formats a local slot time value as HH:mm.
                const value = slot?.[key];

                if (typeof value !== 'string') return null;

                const time = moment(value.replace(' ', 'T'));

                if (!time.isValid()) {
                    return value.substring(11, 16);
                }

                if (adjustPickupTime) {
                    time.subtract(this.getPickupMinutesPrior(), 'minutes');
                }

                return time.format('HH:mm');
            },
            formatSlotTimeRange(slot) {
                // Formats the selected slot as start time with optional end time.
                const startTime = this.formatSlotTime(slot, 'startTimeLocal', true) || this.formatSlotTime(slot, 'startTime', true) || slot?.time;
                const endTime = this.formatSlotTime(slot, 'endTimeLocal') || this.formatSlotTime(slot, 'endTime');

                if (startTime && endTime) return startTime + '-' + endTime;
                return startTime || '';
            },
            saveOverlay() {
                if (!this.canSaveOverlay) {
                    return;
                }

                if (this.overlay.scene === 'message') {
                    this.closeOverlay();
                    return;
                }

                if (this.overlay.scene === 'partnerBook') {
                    this.savePartnerDraft();
                    return;
                }

                if (this.overlay.scene === 'discount') {
                    this.submitPromoCode();
                    return;
                }

                this.updateData();
                this.closeOverlay();
            },
            showMessageOverlay(text, title = 'Kontrollera bokningen', cta = 'Ok') {
                // Shows a reusable overlay message with a single confirmation action.
                this.message.title = title;
                this.message.text = text;
                this.message.cta = cta;
                this.overlay.open = true;
                this.overlay.scene = 'message';
            },
            openPromoOverlay() {
                this.promoDraft = {
                    code: this.order.promo?.code || '',
                    valid: this.order.promo?.valid ? true : null,
                    checking: false,
                    message: '',
                    result: this.order.promo?.valid ? {...this.order.promo} : null,
                };
                this.openOverlay('discount');
            },
            resetPromoDraftValidation() {
                this.promoDraft.valid = null;
                this.promoDraft.message = '';
                this.promoDraft.result = null;
            },
            async verifyPromoCode() {
                const code = (this.promoDraft.code || '').trim();
                if (!code) {
                    this.resetPromoDraftValidation();
                    return;
                }

                if (this.promoDraft.checking) return;

                if (!window.webienSite?.ajaxurl || !window.webienSite?.nonce) {
                    this.promoDraft.message = 'Ajax-inställningar saknas.';
                    this.promoDraft.valid = false;
                    return;
                }

                this.promoDraft.checking = true;
                this.promoDraft.message = 'Verifierar…';

                try {
                    const formData = new FormData();
                    formData.append('action', 'webien_validate_promo_code');
                    formData.append('nonce', window.webienSite.nonce);
                    formData.append('code', code);
                    formData.append('order', JSON.stringify(this.order));
                    formData.append('productData', JSON.stringify(this.productData));

                    const response = await axios.post(window.webienSite.ajaxurl, formData);
                    const data = response.data?.data || {};

                    if (!response.data?.success) {
                        this.promoDraft.valid = false;
                        this.promoDraft.message = data.message || 'Rabattkod ej giltig';
                        this.promoDraft.result = null;
                        return;
                    }

                    this.promoDraft.valid = Boolean(data.valid);
                    this.promoDraft.message = data.message || (data.valid ? 'Rabattkod giltig' : 'Rabattkod ej giltig');
                    this.promoDraft.result = data.valid ? data : null;
                } catch (error) {
                    console.error('Promo code validation error', error);
                    this.promoDraft.valid = false;
                    this.promoDraft.message = 'Rabattkod ej giltig';
                    this.promoDraft.result = null;
                } finally {
                    this.promoDraft.checking = false;
                }
            },
            async submitPromoCode() {
                await this.verifyPromoCode();
                if (this.promoDraft.valid === true) {
                    this.applyPromoCode();
                }
            },
            applyPromoCode() {
                if (this.promoDraft.valid !== true || !this.promoDraft.result) {
                    return;
                }

                const result = this.promoDraft.result;
                this.order.promo = {
                    code: result.code || this.promoDraft.code.trim(),
                    valid: true,
                    originalTotal: result.originalTotal ?? null,
                    newTotal: result.newTotal ?? null,
                    discountAmount: result.discountAmount ?? null,
                    currency: result.currency || this.priceCurrency,
                };

                this.updateData();
                this.closeOverlay();
            },
            removePromoCode() {
                this.order.promo = {
                    code: null,
                    valid: false,
                    originalTotal: null,
                    newTotal: null,
                    discountAmount: null,
                    currency: null,
                };
                this.updateData();
            },
            formatCurrency(amount, currency = 'SEK') {
                return new Intl.NumberFormat('sv-SE', {
                    style: 'currency',
                    currency: currency || 'SEK',
                    maximumFractionDigits: 0,
                }).format(Number(amount) || 0);
            },
            async confirmAndBook() {

                // Creates the Rezdy booking before starting the Stripe payment step.
                const validationError = this.getBookingValidationError();
                if (validationError) {
                    this.showMessageOverlay(validationError);
                    return;
                }


                this.prepareRezdyOrderData();
                this.updateData();
                this.booking.error = null;
                this.booking.loading = true;
                this.overlay.open = true;
                this.overlay.scene = 'loading';


                try {
                    // Creates the Rezdy booking and then starts the Stripe payment step.
                    const booking = await this.createRezdyBooking();
                    this.booking.rezdyOrder = booking;
                    this.order.rezdyBooking = booking;
                    this.updateData();
                    this.overlay.scene = 'payment';

                    this.$nextTick(() => {
                        this.submitBooking();
                    });
                } catch (error) {
                    this.booking.error = error?.response?.data?.data?.message || error?.message || 'Kunde inte skapa bokningen.';
                    this.overlay.scene = 'bookingError';
                } finally {
                    this.booking.loading = false;
                }
            },
            getBookingValidationError() {
                // Checks the minimum data needed before creating a Rezdy booking.
                const email = this.order.contact.email || this.order.contact.mail || '';

                if (!this.order.payAgreement) return 'Du måste godkänna betalningsvillkoren innan du kan gå vidare.';
                if (!this.productData.id) return 'Produkt saknas.';
                if (!this.hasSelectedDateTime) return 'Du behöver välja datum och tid.';
                if (this.totalQuantity < this.quantityMin) return this.quantityMin > 1 ? 'Turen kräver minst ' + this.quantityMin + ' deltagare.' : 'Välj antal deltagare.';
                if (this.quantityMax && this.totalQuantity > this.quantityMax) return 'Turen tillåter högst ' + this.quantityMax + ' deltagare per bokning.';
                if (!this.order.contact.fname || !this.order.contact.lname || !this.order.contact.phone) return 'Fyll i kontaktuppgifter innan du bokar.';
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Fyll i en giltig e-postadress innan du bokar.';
                if (!this.getContactCountryCode()) return 'Välj land innan du bokar.';

                const missingField = this.bookingFields.find(field => field.requiredPerBooking && !this.hasFieldValue(field, this.order.fields?.[field.label]));
                if (missingField) return 'Fyll i: ' + missingField.displayLabel;

                for (let i = 0; i < this.totalQuantity; i++) {
                    const missing = this.participantFields.find(field => !this.hasFieldValue(field, this.order.participants?.[i]?.[field.label]));
                    if (missing) return 'Fyll i ' + missing.displayLabel + ' för deltagare ' + (i + 1) + '.';
                }

                return null;
            },
            prepareRezdyOrderData() {
                // Adds the Rezdy booking fields needed by the backend to the saved order.
                this.normalizeOrder();
                this.normalizeContact();

                this.order.rezdy = {
                    productCode: this.productData.id,
                    productName: this.productData.name,
                    startTimeLocal: this.order.slot?.startTimeLocal,
                    endTimeLocal: this.order.slot?.endTimeLocal || null,
                    pickupLocation: this.selectedPickup || null,
                    quantities: this.getRezdyQuantities(),
                };
            },
            getRezdyQuantities() {
                // One Rezdy quantity row per price option with a count.
                return this.priceOptionRows
                    .filter(row => row.count > 0)
                    .map(row => ({optionId: row.id, optionLabel: row.rezdyLabel, value: row.count}));
            },
            getPriceOptionKey(option) {
                return String(option?.id ?? option?.label ?? '');
            },
            formStepNumber(name) {
                // Step numbers in the checkout form follow the cards that are shown.
                const steps = ['contact'];
                if (this.hasDetailsCard) steps.push('details');
                if (this.showParticipantsCard) steps.push('participants');
                steps.push('terms');

                return steps.indexOf(name) + 1;
            },
            isLongTextField(field) {
                return field.type === 'String' && /requirement|önskemål|allergi|restri/i.test(field.label + ' ' + field.displayLabel);
            },
            getFieldInputType(field) {
                if (field.type === 'Phone') return 'tel';
                if (field.type === 'Date') return 'date';

                return 'text';
            },
            toggleBooleanField(target, label) {
                target[label] = target[label] !== true;
                this.updateData();
            },
            toggleOptionalParticipants() {
                // Opening the optional part fills in participant 1 from the contact person.
                this.optionalParticipantsOpen = !this.optionalParticipantsOpen;

                const first = this.order.participants?.[0];
                if (this.optionalParticipantsOpen && first) {
                    const contactValues = {'first name': this.order.contact.fname, 'last name': this.order.contact.lname};

                    this.optionalParticipantFields.forEach(field => {
                        const value = contactValues[field.label.trim().toLowerCase()];
                        if (value && !first[field.label]) first[field.label] = value;
                    });
                }
            },
            isParticipantFieldShown(field) {
                return field.requiredPerParticipant || this.optionalParticipantsOpen;
            },
            changeExtra(extra, add) {
                // Quantity extras count up and down; other extras are on or off.
                const current = Number(this.order.extras?.[extra.name] || 0);
                const next = extra.priceType === 'QUANTITY' ? Math.max(0, current + (add ? 1 : -1)) : (add ? 1 : 0);

                this.order.extras = {...this.order.extras, [extra.name]: next};
                this.updateData();
            },
            hasFieldValue(field, value) {
                if (field.type === 'Boolean') return value === true || value === 'true';
                return String(value ?? '').trim() !== '';
            },
            normalizeContact() {
                // Keeps legacy mail/email fields in sync for backend booking and Stripe.
                this.order.contact.email = this.order.contact.email || this.order.contact.mail || null;
                this.order.contact.mail = this.order.contact.mail || this.order.contact.email || null;
            },
            async createRezdyBooking() {
                // Sends the current order to WordPress to create a Rezdy booking.
                if (!window.webienSite?.ajaxurl || !window.webienSite?.nonce) {
                    throw new Error('Ajax-inställningar saknas.');
                }

                const formData = new FormData();
                formData.append('action', 'webien_create_rezdy_booking');
                formData.append('nonce', window.webienSite.nonce);
                formData.append('order', JSON.stringify(this.order));
                formData.append('productData', JSON.stringify(this.productData));

                const response = await axios.post(window.webienSite.ajaxurl, formData);

                if (!response.data?.success) {
                    throw new Error(response.data?.data?.message || 'Rezdy kunde inte skapa bokningen.');
                }

                return response.data.data;
            },
            canChangeQuantity(row, add) {
                if (!add) return row.count > 0;
                if (row.max && row.count >= row.max) return false;
                if (this.quantityMax && this.totalQuantity >= this.quantityMax) return false;

                return true;
            },
            changeQuantity(row, add) {
                // Adds or removes one of a price option, within Rezdy's limits.
                if (!this.canChangeQuantity(row, add)) return;

                let next = row.count + (add ? 1 : -1);

                // Options with a minimum (e.g. groups) jump between 0 and the minimum.
                if (row.min > 1) {
                    next = add ? Math.max(next, row.min) : (next < row.min ? 0 : next);
                }

                this.order.quantities = {...this.order.quantities, [row.key]: next};
                this.updateData();
            },
            resizeParticipants() {
                // Keeps one participant row per booked unit when the product has participant fields.
                if (!this.showParticipantsCard) return;

                const rows = Array.isArray(this.order.participants) ? [...this.order.participants] : [];
                while (rows.length < this.totalQuantity) rows.push({});
                rows.length = this.totalQuantity;
                this.order.participants = rows;
            },
            updateData() {
                // Update to local storage
                let data = {
                    sourceInstanceId: this.settings.instanceId,
                    order: this.order,
                    productData: this.productData,
                }
                localStorage.setItem(bookingStorageKey, JSON.stringify(data));

                // Emit global event to other instances
                let event = new CustomEvent(bookingDataEvent, {detail: data});
                window.dispatchEvent(event);

            },
            resetData() {
                // Reset to data from local storage
                let data = null;

                try {
                    data = JSON.parse(localStorage.getItem(bookingStorageKey));
                } catch (error) {
                    data = null;
                }

                if (data?.order) {
                    this.order = {...this.order, ...data.order};
                    this.syncProductData(data.productData);
                }

                this.normalizeOrder();
            },
            updatePartnerCart() {
                const data = {
                    sourceInstanceId: this.settings.instanceId,
                    partnerCart: this.normalizePartnerCart(this.partnerCart),
                };

                this.syncingPartnerCart = true;
                this.partnerCart = data.partnerCart;
                localStorage.setItem(partnerCartStorageKey, JSON.stringify(data));
                window.dispatchEvent(new CustomEvent(partnerCartEvent, {detail: data}));
                this.$nextTick(() => {
                    this.syncingPartnerCart = false;
                });
            },
            resetPartnerCart() {
                let data = null;

                try {
                    data = JSON.parse(localStorage.getItem(partnerCartStorageKey));
                } catch (error) {
                    data = null;
                }

                if (!data?.partnerCart) {
                    return;
                }

                this.syncingPartnerCart = true;
                this.partnerCart = this.normalizePartnerCart(data.partnerCart);
                this.$nextTick(() => {
                    this.syncingPartnerCart = false;
                });
            },
            normalizePartnerCart(cart = {}) {
                const contact = cart.contact || {};
                const extra = cart.extra || {};
                const items = Array.isArray(cart.items) ? cart.items : [];

                return {
                    contact: {
                        company: contact.company || null,
                        fname: contact.fname || null,
                        lname: contact.lname || null,
                        email: contact.email || null,
                        phone: contact.phone || null,
                        country: contact.country || null,
                    },
                    extra: {
                        note: extra.note || '',
                    },
                    items: items.map((item) => ({
                        id: item.id || this.createPartnerCartItemId(),
                        product: this.normalizePartnerProduct(item.product || {}),
                        travelers: Number(item.travelers || 1),
                        desiredDate: item.desiredDate || null,
                        desiredPickup: item.desiredPickup || null,
                        totPrice: Number(item.totPrice || 0),
                        guideLanguage: item.guideLanguage || null,
                        resource: item.resource || null,
                        comment: item.comment || '',
                        createdAt: item.createdAt || null,
                        updatedAt: item.updatedAt || null,
                    })),
                    payAgreement: Boolean(cart.payAgreement),
                };
            },
            normalizeOrder() {
                // Makes saved booking data match the current product and order shape.
                const productCode = this.productData.id || null;
                const sameProduct = !this.order.productCode || this.order.productCode === productCode;

                this.order.extra = {
                    pickup: (this.order.extra || {}).pickup || null,
                    note: (this.order.extra || {}).note || '',
                };
                delete this.order.travelers;

                if (!sameProduct) {
                    // Another product was in progress: keep the contact details, reset the rest.
                    this.order.slot = null;
                    this.order.promo = {code: null, valid: false, originalTotal: null, newTotal: null, discountAmount: null, currency: null};
                    this.order.quantities = {};
                    this.order.fields = {};
                    this.order.participants = [];
                    this.order.extras = {};
                    this.order.extra.pickup = null;
                }

                this.order.productCode = productCode;
                this.order.fields = this.order.fields && typeof this.order.fields === 'object' ? this.order.fields : {};
                this.order.participants = Array.isArray(this.order.participants) ? this.order.participants : [];
                this.order.extras = this.order.extras && typeof this.order.extras === 'object' ? this.order.extras : {};

                // Only keep quantities for this product's price options.
                const keys = this.priceOptionRows.map(row => row.key);
                const quantities = {};
                Object.keys(this.order.quantities || {}).forEach(key => {
                    if (keys.includes(key) && Number(this.order.quantities[key]) > 0) {
                        quantities[key] = Number(this.order.quantities[key]);
                    }
                });

                // Start with the minimum number on the first price option.
                if (Object.keys(quantities).length === 0 && keys.length > 0) {
                    const first = this.priceOptionRows[0];
                    quantities[first.key] = Math.max(this.quantityMin, first.min || 1);
                }

                this.order.quantities = quantities;
                this.resizeParticipants();
            },
            syncProductData(productData) {
                // Shares product data with the checkout widgets, which have no product of their own.
                // A page that renders its own product always keeps its fresh data from the server.
                if (!productData || !productData.id) {
                    return;
                }

                if (this.settings.productData?.id) {
                    return;
                }

                this.settings.productData = productData;
            },
            resetLocalStorage() {
                localStorage.removeItem(bookingStorageKey);
                localStorage.removeItem(partnerCartStorageKey);
            },
            showConditions() {
                console.log('showConditions');
            },
            togglePayAgreement() {
                this.order.payAgreement = !this.order.payAgreement;
                this.updateData();

            },
            togglePartnerPayAgreement() {
                this.partnerCart.payAgreement = !this.partnerCart.payAgreement;

            },
            submitBooking() {
                // Starts the Stripe payment session for this booking.
                this.mountStripeElements();
            },
            initStripe() {
                // Creates the Stripe browser object from the public key.
                if (typeof Stripe === 'undefined') {
                    this.stripe.error = 'Stripe kunde inte laddas.';
                    return;
                }

                this.stripe.$ = Stripe(this.stripe.apiKey);

            },
            async mountStripeElements() {
                // Requests a Checkout Session from WordPress and mounts Stripe Elements in the overlay.
                if (this.stripe.loading || this.stripe.paymentElement) return;
                if (!this.stripe.$) this.initStripe();
                if (!this.stripe.$) return;

                if (typeof this.stripe.$.initCheckoutElementsSdk !== 'function') {
                    this.stripe.error = 'Stripe Elements kunde inte startas. Ladda om sidan och försök igen.';
                    return;
                }

                this.stripe.error = null;
                this.stripe.statusMessage = null;
                this.stripe.paymentResult = null;
                this.stripe.loading = true;

                try {
                    const sessionData = await this.createStripeCheckoutSession();
                    const elementsOptions = {
                        appearance: this.getStripeAppearance(),
                    };
                    const stripeFonts = this.getStripeFonts();

                    if (stripeFonts.length) {
                        elementsOptions.fonts = stripeFonts;
                    }

                    const checkout = this.stripe.$.initCheckoutElementsSdk({
                        clientSecret: sessionData.clientSecret,
                        elementsOptions,
                    });

                    this.stripe.clientSecret = sessionData.clientSecret;
                    this.stripe.sessionId = sessionData.sessionId;
                    this.stripe.checkout = checkout;
                    this.order.stripeCheckoutSessionId = sessionData.sessionId;
                    this.updateData();

                    checkout.on('change', (session) => {
                        this.handleStripeSessionChange(session);
                    });

                    const loadActionsResult = await checkout.loadActions();

                    if (loadActionsResult.type !== 'success') {
                        throw new Error(loadActionsResult.error?.message || 'Kunde inte ladda Stripe-betalningen.');
                    }

                    this.stripe.actions = loadActionsResult.actions;
                    this.handleStripeSessionChange(loadActionsResult.actions.getSession());

                    const paymentElement = checkout.createPaymentElement({
                        layout: 'tabs',
                        fields: {
                            billingDetails: {
                                name: 'never',
                                email: 'never',
                                phone: 'never',
                                address: {
                                    country: 'never',
                                },
                            },
                        },
                        wallets: {
                            applePay: 'never',
                            googlePay: 'never',
                            link: 'never',
                        },
                        terms: {
                            card: 'never',
                        },
                        paymentMethodOrder: ['card'],
                    });
                    paymentElement.mount('#stripe-payment-element-' + this.settings.instanceId);
                    this.stripe.paymentElement = paymentElement;
                } catch (error) {
                    this.stripe.error = error?.response?.data?.data?.message || error?.message || 'Kunde inte starta betalningen.';
                } finally {
                    this.stripe.loading = false;
                }
            },
            async createStripeCheckoutSession() {
                // Sends the current booking data to the backend Checkout Session endpoint.
                if (!window.webienSite?.ajaxurl || !window.webienSite?.nonce) {
                    throw new Error('Ajax-inställningar saknas.');
                }

                const formData = new FormData();
                formData.append('action', 'webien_create_stripe_checkout_session');
                formData.append('nonce', window.webienSite.nonce);
                formData.append('order', JSON.stringify(this.order));

                const response = await axios.post(window.webienSite.ajaxurl, formData);

                if (!response.data?.success || !response.data?.data?.clientSecret) {
                    throw new Error(response.data?.data?.message || 'Stripe session saknas.');
                }

                return response.data.data;
            },
            handleStripeSessionChange(session) {
                // Keeps local UI in sync with Stripe Checkout session state.
                if (!session) return;

                this.stripe.session = session;
                this.stripe.canConfirm = Boolean(session.canConfirm);

                if (session.lastPaymentError?.message) {
                    this.stripe.error = session.lastPaymentError.message;
                }
            },
            async confirmStripePayment() {
                // Confirms the Checkout Session and then verifies it server-side.
                if (!this.stripe.actions || this.stripe.processing || this.stripe.loading) return;

                this.stripe.error = null;
                this.stripe.statusMessage = null;
                this.stripe.processing = true;
                let paymentConfirmed = false;

                try {
                    const result = await this.stripe.actions.confirm(this.getStripeConfirmOptions());

                    if (result?.type === 'error') {
                        throw new Error(result.error?.message || 'Betalningen kunde inte genomföras.');
                    }

                    paymentConfirmed = true;
                    const syncResult = await this.syncStripeCheckoutSession();
                    this.stripe.paymentResult = syncResult;
                    this.stripe.statusMessage = this.getPaymentStatusMessage(syncResult);
                    this.overlay.scene = 'paymentSuccess';
                    this.destroyStripeCheckout();
                } catch (error) {
                    const message = error?.response?.data?.data?.message || error?.message || 'Betalningen kunde inte genomföras.';

                    if (error?.refunded) {
                        // Resold product: the supplier booking failed after payment and the money was refunded.
                        this.booking.error = message;
                        this.overlay.scene = 'bookingError';
                        this.destroyStripeCheckout();
                    } else if (paymentConfirmed) {
                        this.stripe.paymentResult = {
                            verificationError: message,
                        };
                        this.stripe.statusMessage = 'Betalningen är mottagen, men bokningsstatus kunde inte verifieras automatiskt: ' + message;
                        this.overlay.scene = 'paymentSuccess';
                        this.destroyStripeCheckout();
                    } else {
                        this.stripe.error = message;
                    }
                } finally {
                    this.stripe.processing = false;
                }
            },
            async syncStripeCheckoutSession(sessionId = this.stripe.sessionId) {
                // Asks the server to retrieve Stripe state and apply the Rezdy status update.
                if (!window.webienSite?.ajaxurl || !window.webienSite?.nonce) {
                    throw new Error('Ajax-inställningar saknas.');
                }

                if (!sessionId) {
                    throw new Error('Stripe session saknas.');
                }

                const formData = new FormData();
                formData.append('action', 'webien_sync_stripe_checkout_session');
                formData.append('nonce', window.webienSite.nonce);
                formData.append('sessionId', sessionId);

                const response = await axios.post(window.webienSite.ajaxurl, formData);

                if (!response.data?.success) {
                    const error = new Error(response.data?.data?.message || 'Kunde inte verifiera Stripe-betalningen.');
                    error.refunded = Boolean(response.data?.data?.refunded);
                    throw error;
                }

                return response.data.data;
            },
            async handleStripeReturn() {
                // Completes server-side reconciliation after redirect-based payment methods.
                const params = new URLSearchParams(window.location.search);
                const sessionId = params.get('stripe_session_id');

                if (!sessionId || this.order.stripeCheckoutSessionId !== sessionId) {
                    return;
                }

                this.stripe.sessionId = sessionId;
                this.overlay.open = true;
                this.overlay.scene = 'loading';

                try {
                    const syncResult = await this.syncStripeCheckoutSession(sessionId);
                    this.stripe.paymentResult = syncResult;
                    this.stripe.statusMessage = this.getPaymentStatusMessage(syncResult);
                    this.overlay.scene = 'paymentSuccess';
                } catch (error) {
                    const message = error?.response?.data?.data?.message || error?.message || 'Kunde inte verifiera Stripe-betalningen.';
                    if (error?.refunded) {
                        this.booking.error = message;
                        this.overlay.scene = 'bookingError';
                        return;
                    }
                    this.stripe.paymentResult = {
                        verificationError: message,
                    };
                    this.stripe.statusMessage = 'Betalningen kunde inte verifieras automatiskt: ' + message;
                    this.overlay.scene = 'paymentSuccess';
                }
            },
            getStripeAppearance() {
                // Matches Stripe Elements with the booking overlay without handling card data.
                const fontFamily = window.webienStripeElements?.fontFamily || '"Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

                return {
                    theme: 'stripe',
                    inputs: 'spaced',
                    labels: 'above',
                    variables: {
                        colorPrimary: '#70479C',
                        colorBackground: '#ffffff',
                        colorText: '#424242',
                        colorDanger: '#FC4040',
                        borderRadius: '8px',
                        fontFamily,
                        fontSizeBase: '16px',
                        fontWeightLight: '300',
                        fontWeightNormal: '400',
                        fontWeightMedium: '500',
                        fontWeightBold: '700',
                        spacingUnit: '4px',
                    },
                    rules: {
                        '.Input': {
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            boxShadow: 'none',
                        },
                        '.Input:focus': {
                            border: '1px solid #70479C',
                            boxShadow: '0 0 0 1px #70479C',
                        },
                        '.Label': {
                            color: '#424242',
                            fontWeight: '500',
                        },
                        '.Tab': {
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                            boxShadow: 'none',
                        },
                        '.Tab:hover': {
                            color: '#70479C',
                        },
                        '.Tab--selected': {
                            borderColor: '#70479C',
                            boxShadow: '0 0 0 1px #70479C',
                        },
                    },
                };
            },
            getStripeFonts() {
                const config = window.webienStripeElements || {};
                const fonts = Array.isArray(config.fonts) ? config.fonts.filter((font) => this.canStripeLoadFont(font)) : [];

                if (fonts.length) {
                    return fonts;
                }

                if (config.fallbackFontCss && this.canStripeLoadFont({cssSrc: config.fallbackFontCss})) {
                    return [{cssSrc: config.fallbackFontCss}];
                }

                return [];
            },
            canStripeLoadFont(font) {
                const source = font?.src || font?.cssSrc;

                if (!source || typeof source !== 'string') {
                    return false;
                }

                const urlMatches = Array.from(source.matchAll(/url\(["']?([^"')]+)["']?\)/g));
                const urls = urlMatches.length ? urlMatches.map((match) => match[1]) : [source];

                return urls.every((url) => {
                    try {
                        return new URL(url, window.location.href).protocol === 'https:';
                    } catch (error) {
                        return false;
                    }
                });
            },
            getPaymentStatusMessage(syncResult) {
                // Separates immediate success from delayed payment confirmation.
                if (syncResult?.rezdyStatusUpdated) {
                    return 'Betalningen är godkänd och genomförd.';
                }

                if (syncResult?.paymentPending) {
                    return 'Betalningen behandlas fortfarande. Bokningen uppdateras när Stripe bekräftar betalningen.';
                }

                return 'Betalningen är mottagen och bokningen genomförd.';
            },
            getFinalOrderNumber() {
                return this.stripe.paymentResult?.rezdyOrderNumber
                    || this.order.rezdyBooking?.orderNumber
                    || this.order.rezdyBooking?.booking?.orderNumber
                    || null;
            },
            getFinalOrderStatus() {
                return this.stripe.paymentResult?.rezdyStatus
                    || this.order.rezdyBooking?.booking?.status
                    || this.order.rezdyBooking?.status
                    || null;
            },
            getFinalAmountPaidText() {
                const amount = this.stripe.paymentResult?.amountPaid;
                const currency = this.stripe.paymentResult?.currency;

                if (typeof amount === 'number' && amount > 0 && currency) {
                    return this.formatStripeMinorAmount(amount, currency);
                }

                return this.stripeTotalText;
            },
            formatStripeMinorAmount(amount, currency) {
                const currencyCode = String(currency || 'SEK').toUpperCase();
                const zeroDecimalCurrencies = ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF'];
                const divisor = zeroDecimalCurrencies.includes(currencyCode) ? 1 : 100;

                return new Intl.NumberFormat('sv-SE', {
                    style: 'currency',
                    currency: currencyCode,
                    maximumFractionDigits: divisor === 1 ? 0 : 2,
                }).format(amount / divisor);
            },
            getStripeConfirmOptions() {
                const options = {
                    redirect: 'if_required',
                };
                const billingAddress = this.getStripeBillingAddress();

                // The Checkout Session already has customer_email. Only pass billing
                // details that Payment Element is configured not to collect.
                if (Object.keys(billingAddress).length) {
                    options.billingAddress = billingAddress;
                }

                return options;
            },
            getStripeBillingAddress() {
                const name = this.getContactFullName();
                const country = this.getContactCountryCode();

                if (!name && !country) {
                    return {};
                }

                const billingAddress = {
                    address: {},
                };

                if (name) {
                    billingAddress.name = name;
                }

                if (country) {
                    billingAddress.address.country = country;
                }

                return billingAddress;
            },
            getContactEmail() {
                const email = this.order.contact.email || this.order.contact.mail || '';

                return String(email).trim() || undefined;
            },
            getContactPhone() {
                return String(this.order.contact.phone || '').trim() || undefined;
            },
            getContactFullName() {
                // Provides hidden billing name to Stripe when the Payment Element does not collect it.
                return [this.order.contact.fname, this.order.contact.lname]
                    .map(value => String(value || '').trim())
                    .filter(Boolean)
                    .join(' ') || undefined;
            },
            getContactCountryCode() {
                const country = this.order.contact.country;

                if (!country) {
                    return undefined;
                }

                if (typeof country === 'object' && country.code) {
                    return String(country.code).trim().toUpperCase() || undefined;
                }

                const countryValue = String(country).trim();

                if (/^[A-Za-z]{2}$/.test(countryValue)) {
                    return countryValue.toUpperCase();
                }

                const option = this.countryList.find(item => item.name === countryValue || item.code === countryValue);

                return option?.code || undefined;
            },
            destroyStripeCheckout() {
                // Removes the mounted Stripe Elements instance from the overlay.
                if (this.stripe.paymentElement) {
                    if (typeof this.stripe.paymentElement.destroy === 'function') {
                        this.stripe.paymentElement.destroy();
                    } else if (typeof this.stripe.paymentElement.unmount === 'function') {
                        this.stripe.paymentElement.unmount();
                    }
                }

                if (this.stripe.checkout && typeof this.stripe.checkout.destroy === 'function') {
                    this.stripe.checkout.destroy();
                }

                this.stripe.checkout = null;
                this.stripe.actions = null;
                this.stripe.paymentElement = null;
                this.stripe.session = null;
                this.stripe.clientSecret = null;
                this.stripe.canConfirm = false;
            },
            async sendQuote() {
                if (this.partnerQuoteResult.sending) {
                    return;
                }

                const quote = this.normalizePartnerCart(this.partnerCart);
                const errors = this.getPartnerQuoteValidationErrors(quote);

                this.partnerCart = quote;
                this.updatePartnerCart();

                if (errors.length) {
                    console.warn('Partner quote request missing fields', errors);
                    return;
                }

                if (!window.webienSite?.ajaxurl || !window.webienSite?.nonce) {
                    console.error('Ajax-inställningar saknas.');
                    return;
                }

                const formData = new FormData();
                formData.append('action', 'webien_partner_send_quote');
                formData.append('nonce', window.webienSite.nonce);
                formData.append('quote', JSON.stringify(quote));

                this.partnerQuoteResult.sending = true;
                this.partnerQuoteResult.error = null;

                try {
                    const response = await axios.post(window.webienSite.ajaxurl, formData);

                    if (!response.data?.success) {
                        this.partnerQuoteResult.sending = false;
                        this.partnerQuoteResult.error = response.data?.data?.message || 'Kunde inte skicka offertförfrågan.';
                        console.error('Partner quote request failed', response.data);
                        return;
                    }

                    console.log('Partner quote request sent', response.data.data);

                    const uuid = response.data.data?.uuid;
                    const thankYouUrl = this.settings.thankYouUrl;

                    if (uuid && thankYouUrl) {
                        const separator = thankYouUrl.includes('?') ? '&' : '?';
                        window.location.href = thankYouUrl + separator + 'quote=' + encodeURIComponent(uuid);
                        return;
                    }

                    this.partnerQuoteResult.sending = false;
                } catch (error) {
                    this.partnerQuoteResult.sending = false;
                    this.partnerQuoteResult.error = error?.response?.data?.data?.message || error?.message || 'Kunde inte skicka offertförfrågan.';
                    console.error('Partner quote request error', error);
                }
            },
            isPartnerItemExpanded(index) {
                return this.partnerQuoteResult.expandedItems.includes(index);
            },
            togglePartnerItemDetails(index) {
                const list = this.partnerQuoteResult.expandedItems;
                const position = list.indexOf(index);

                if (position === -1) {
                    list.push(index);
                } else {
                    list.splice(position, 1);
                }
            },
            async fetchPartnerQuote() {
                const uuid = new URLSearchParams(window.location.search).get('quote');

                if (!uuid) {
                    this.partnerQuoteResult.notFound = true;
                    return;
                }

                if (!window.webienSite?.ajaxurl) {
                    this.partnerQuoteResult.notFound = true;
                    return;
                }

                this.partnerQuoteResult.loading = true;
                this.partnerQuoteResult.notFound = false;
                this.partnerQuoteResult.error = null;
                this.partnerQuoteResult.uuid = uuid;

                try {
                    const formData = new FormData();
                    formData.append('action', 'webien_partner_get_quote');
                    formData.append('uuid', uuid);

                    const response = await axios.post(window.webienSite.ajaxurl, formData);

                    if (!response.data?.success) {
                        this.partnerQuoteResult.notFound = true;
                        return;
                    }

                    const data = response.data.data;
                    if (!data?.quote) {
                        this.partnerQuoteResult.notFound = true;
                        return;
                    }

                    this.partnerQuoteResult.quote = data.quote;
                    this.partnerQuoteResult.entryId = data.entryId;
                    this.partnerQuoteResult.createdAt = data.createdAt;

                    this.syncingPartnerCart = true;
                    this.partnerCart = this.normalizePartnerCart(data.quote);
                    this.$nextTick(() => {
                        this.syncingPartnerCart = false;
                    });
                } catch (error) {
                    this.partnerQuoteResult.notFound = true;
                    this.partnerQuoteResult.error = error?.message || null;
                } finally {
                    this.partnerQuoteResult.loading = false;
                }
            },
            getPartnerQuoteValidationErrors(quote = this.partnerCart) {
                const errors = [];
                const email = quote.contact.email || '';

                if (!quote.items.length) errors.push('Minst en produkt behöver läggas till.');
                if (!quote.contact.company) errors.push('Företag saknas.');
                if (!quote.contact.fname || !quote.contact.lname) errors.push('Kontaktperson saknas.');
                if (!quote.contact.phone) errors.push('Telefonnummer saknas.');
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.push('Giltig e-post saknas.');
                if (!quote.contact.country) errors.push('Land saknas.');

                return errors;
            },
            removePartnerItem() {
                // Remove the item that is current partnerDraft and also delete it from local storage.
                if (!this.partnerDraft) return;

                const itemId = this.partnerDraft.id;
                this.partnerCart.items = this.partnerCart.items.filter(item => item.id !== itemId);
                this.updatePartnerCart();
                this.closeOverlay();

            },
            getFormatedPrice(price, currency = 'SEK') {
                return new Intl.NumberFormat('sv-SE', {
                    style: 'currency',
                    currency: currency || 'SEK',
                    maximumFractionDigits: 0,
                }).format(price);
            },
            formatDate(dateString, format = 'YYYY-MM-DD') {
                if(format === 'D MMM') {
                    return moment(dateString).format('D') + ' ' + monthNamesShort[moment(dateString).format('M') - 1];
                }
                return moment(dateString).format(format)


            }
        },
        mounted: function () {
            this.init();
        },
        created() {

        },
        components: {},
    });


    // Mount app to DOM
    if (document.getElementById('bookItem-' + item.dataset.unique)) {
        $app.mount('#bookItem-' + item.dataset.unique);
        $app.use(VCalendar, {})

    }

});
